// extracted by mini-css-extract-plugin
module.exports = {"bar":"_5D2RxrTW","icon":"_5D3U0CVG","info-container":"_5D32b8jz","modal":"_5D2rXVLJ"};